import { createSlice } from '@reduxjs/toolkit';
import {
  HandlersActionResponse,
  HandlersDeliverableCreateRequest,
} from '../athenaApiGen';
import { DEFAULT_TABLE_PAGE_SIZE } from '../../utils/tableVariables';

type TCreateOpenModalObj = {
  isOpen: boolean;
  cloneDeliverable?: HandlersDeliverableCreateRequest;
};

type TDeliverableInitialState = {
  createOpenModal: TCreateOpenModalObj;
  isEditModalOpen: boolean;
  isViewPanelOpen: boolean;
  expandedPanel: boolean;
  page: number;
  pageSize: number;
  selectedRowId?: string | null;
  allowedActions: HandlersActionResponse[];
  // Toolbar filters. Null/empty => no filter applied.
  projectIdFilter: string | null;
  typeIdFilter: string | null;
  authorIdFilter: string | null;
};

const initialState: TDeliverableInitialState = {
  createOpenModal: {
    isOpen: false,
  },
  isEditModalOpen: false,
  isViewPanelOpen: false,
  expandedPanel: false,
  page: 0,
  pageSize: DEFAULT_TABLE_PAGE_SIZE,
  allowedActions: [],
  projectIdFilter: null,
  typeIdFilter: null,
  authorIdFilter: null,
};

const deliverablesSlice = createSlice({
  name: 'deliverables',
  initialState,
  reducers: {
    setCreateModal: (state, action) => {
      state.createOpenModal = action.payload;
    },
    setEditModalOpen: (state, action) => {
      state.isEditModalOpen = action.payload;
    },
    setViewPanel: (state, action) => {
      state.isViewPanelOpen = action.payload;
      if (!action.payload) {
        state.expandedPanel = false;
      }
    },
    setExpandedPanel: (state, action) => {
      state.expandedPanel = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSelectedRowId: (state, action) => {
      state.selectedRowId = action.payload;
    },
    setAllowedActions: (state, action) => {
      state.allowedActions = action.payload;
    },
    setProjectIdFilter: (state, action) => {
      state.projectIdFilter = action.payload;
      // Reset paging when a filter changes so we don't land on a page
      // that no longer exists in the filtered result.
      state.page = 0;
    },
    setTypeIdFilter: (state, action) => {
      state.typeIdFilter = action.payload;
      state.page = 0;
    },
    setAuthorIdFilter: (state, action) => {
      state.authorIdFilter = action.payload;
      state.page = 0;
    },
  },
});
const {
  setCreateModal,
  setEditModalOpen,
  setExpandedPanel,
  setPage,
  setPageSize,
  setSelectedRowId,
  setViewPanel,
  setAllowedActions,
  setProjectIdFilter,
  setTypeIdFilter,
  setAuthorIdFilter,
} = deliverablesSlice.actions;

export {
  setAllowedActions,
  setCreateModal,
  setEditModalOpen,
  setExpandedPanel,
  setPage,
  setPageSize,
  setSelectedRowId,
  setViewPanel,
  setProjectIdFilter,
  setTypeIdFilter,
  setAuthorIdFilter,
};

export default deliverablesSlice.reducer;
